module.exports = __webpack_public_path__ + "a85ccf360fecc9e944dae3617f131577.woff2";